import React from "react";
import { MessageSquare, PencilRuler, Hammer, Rocket, LifeBuoy } from "lucide-react";
import { useReveal } from "@/hooks/useReveal";

const steps = [
  {
    icon: MessageSquare,
    title: "Talk",
    desc: "We learn your business, your customers, and what you need the site to do.",
  },
  {
    icon: PencilRuler,
    title: "Design",
    desc: "You see a design tailored to your brand and goals before anything gets built.",
  },
  {
    icon: Hammer,
    title: "Build",
    desc: "We build it fast, clean, and mobile-friendly — your real content, not placeholders.",
  },
  {
    icon: Rocket,
    title: "Launch",
    desc: "We handle hosting, your domain, and getting you found on Google.",
  },
  {
    icon: LifeBuoy,
    title: "Support",
    desc: "A real person for changes, updates, and help.",
  },
];

export default function Process() {
  const gridRef = useReveal();

  return (
    <section className="relative py-16 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-accent/80">
            How It Works
          </span>
          <h2 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl text-foreground text-balance">
            Five simple steps from idea to website launch.
          </h2>
          <p className="mt-5 text-lg text-foreground/70">
            No tech jargon, no mystery. You always know what's happening and why.
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                className="reveal relative p-6 rounded-[1.5rem] bg-card border border-border/70 hover:border-accent/30 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 rounded-2xl bg-accent/10 text-accent flex items-center justify-center">
                    <Icon size={20} />
                  </span>
                  <span className="font-heading font-extrabold text-3xl text-chart-3/30">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="mt-5 font-heading font-bold text-lg text-foreground">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-foreground/70 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}